import axios from "axios";

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_URL || "http://localhost:4001/api",
  // baseURL: "http://localhost:4000/api",
  baseURL: "https://naavvaayu-backend-test-g5arhvcfcacccpe2.centralindia-01.azurewebsites.net/api",
  headers: {
    "Content-Type": "application/json",
  },
});
  
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
});
  
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't dispatch sessionExpired for API errors - only InactivityContext should handle session expiry
    // This allows lock errors (409) and other API errors to be handled without showing session modal
    return Promise.reject(error);
  }
);
  
export default api;
